import { Language } from './types';

const BASE_LANGUAGE = {
  obdFirstSubtitleCOL:
    'Please introduce your bank account number to connect it with your EFEX account',
  obdPlaceholderAccountCOL: 'Account Number',
  obdKybStepOneFirstCOL:
    'ID from the Legal Representative of the Company (e.g. passport, citizenship card, etc)',
  contactPlaceholderAccountCOL: 'Account Number',
  profileTypeAccountCOL: 'NIT (Tax Identification Number)',
  profileUserNameCOL: 'User Name',
  profileContactAccountCOL: 'Account Number',
  obdFirstSubtitleMX:
    'Please introduce your CLABE to connect it with your EFEX account',
  obdPlaceholderAccountMX: 'Account Clabe',
  obdKybStepOneFirstMX:
    'ID from the Legal Representative of the Company (e.g. passport, license, etc)',
  contactPlaceholderAccountMX: 'Account Clabe',
  profileTypeAccountMX: 'RFC (Federal Taxpayer Registry)',
  profileUserNameMX: 'User Name',
  profileContactAccountMX: 'Account Clabe',
  obdFirstSubtitleUSA:
    'Please introduce your Account Number and Routing Number to connect it with your EFEX account',
  obdPlaceholderAccountUSA: 'Routing Number (for domestic wires)',
  obdKybStepOneFirstUSA:
    'ID from the Legal Representative of the Company (e.g. passport, license, etc)',
  contactPlaceholderAccountUSA: 'Routing Number / ABA',
  profileTypeAccountUSA: 'Tax ID',
  profileContactAccountUSA: 'Routing Number',
  profileUserNameUSA: 'User Name',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE;

const COUNTRY_TRANSLATE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string | object>
> = {
  EN: BASE_LANGUAGE,
  ES: {
    obdFirstSubtitleCOL:
      'Por favor introduce tu Número de Cuenta bancaria para conectarla con tu cuenta de EFEX',
    obdPlaceholderAccountCOL: 'Número de cuenta',
    obdKybStepOneFirstCOL:
      'Identificación oficial vigente del Representante Legal de la Empresa (Pasaporte, cédula de ciudadanía, etc)',
    contactPlaceholderAccountCOL: 'Número de cuenta',
    profileTypeAccountCOL: 'NIT (Número de Identificación Tributaria)',
    profileContactAccountCOL: 'Número de cuenta',
    profileUserNameCOL: 'Nombre de Usuario',
    obdFirstSubtitleMX:
      'Por favor introduce tu CLABE Interbancaria para conectarla con tu cuenta EFEX,',
    obdPlaceholderAccountMX: 'Cuenta Clabe',
    obdKybStepOneFirstMX:
      'Identificación oficial vigente del Representante Legal de la Empresa (INE, pasaporte, cédula profesional, cartilla militar, etc)',
    contactPlaceholderAccountMX: 'Cuenta Clabe',
    profileTypeAccountMX: 'RFC (Registro Federal de Contribuyentes)',
    profileContactAccountMX: 'Cuenta Clabe',
    profileUserNameMX: 'Nombre de Usuario',
    obdFirstSubtitleUSA:
      'Por favor introduce tu Número de Cuenta y Número Routing para conectarla con tu cuenta EFEX',
    obdPlaceholderAccountUSA: 'Número Routing (para wires domésticos)',
    obdKybStepOneFirstUSA:
      'Identificación oficial vigente del Representante Legal de la Empresa (INE, pasaporte, cédula profesional, cartilla militar, etc)',
    contactPlaceholderAccountUSA: 'Número Routing / ABA',
    profileTypeAccountUSA: 'Tax ID',
    profileContactAccountUSA: 'Número Routing',
    profileUserNameUSA: 'User Name',
  },
};

export default COUNTRY_TRANSLATE_LABELS;
